import { Box, Chip, Stack, Typography } from '@mui/material';
import { STAGES } from '../constants';

export default function StageHeader({ stage }) {
  const s = STAGES[stage];
  if (!s) return null;
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        boxShadow: (t) => t.customShadows.z1,
        p: 2.5,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Chip
          label={`Stage ${stage + 1} of ${STAGES.length}`}
          size="small"
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontWeight: 800,
            fontSize: 10.5,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            height: 24,
          }}
        />
        <Typography variant="h5" sx={{ fontSize: 21, m: 0, letterSpacing: '-.2px' }}>
          {s.label}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ mt: 0.75, color: 'text.secondary', maxWidth: 880 }}>
        {s.explainer}
      </Typography>
    </Box>
  );
}
